import React from 'react';

var p = '';

class Phone extends React.PureComponent{
    render(){

        let phone = this.props.country;

        let continent = this.props.continent;

        console.log(continent)

        if(continent == 'Europe'){
            phone = '(020) 45770272';
        }else{
            switch(phone){
                case 'AU':
                    phone = '(02) 88800313';
                break;
                case 'CA':
                    phone = '(437) 8860987';
                break;
                case 'NZ':
                    phone = '(04) 8881388';
                break;
                case 'SG':
                    phone = '31594885';
                break;
                case 'GB':
                    phone = '(020) 45770272';
                break;
                case 'US':
                    phone = '(929) 5909255';
                break;
                case 'AM':
                    phone = '+374 41 23 03 30';
                break
                default:
                    phone = '(929) 5909255';
                break;
            }
        }

        
        p = phone;

        return(
            phone
        )
    }
}

export{
    Phone,
    p
}